import { useEffect } from "react"
import { useHistory } from "react-router"

export const LogOut = ()=>{

    let history = useHistory()

    useEffect(()=>{

        history.replace('/')

    })

    return(<></>)
}